/**
 * Created by Jerker Nord on 2019-04-16.
 */

import {MotionPathPlugin} from "gsap/dist/MotionPathPlugin";

export interface IBezierThrough {
    readonly y:ISegment[];
    readonly x:ISegment[];
}

export interface ISegment {
    readonly a:number;
    readonly b:number;
    readonly ba:number;
    readonly c:number;
    readonly ca:number;
    readonly d:number;
    readonly da:number;
}

export class GSAPBezierSpline {

    public static interpolate(pointsData:PIXI.IPointData[]):PIXI.Point[] {
        const rawPath = MotionPathPlugin.arrayToRawPath(pointsData, {type:"cubic"});

        let points:PIXI.Point[] = [];
        (<number[][]>rawPath).forEach(p => {
            let start:PIXI.Point = new PIXI.Point(p[0], p[1]);
            let control1:PIXI.Point = new PIXI.Point(p[2], p[3]);
            let control2:PIXI.Point = new PIXI.Point(p[4], p[5]);
            let end:PIXI.Point = new PIXI.Point(p[6], p[7]);
            let t:number = 0;
            while(t < 1.0) {
                points.push(GSAPBezierSpline.interpolateCubicBezier(start, control1, control2, end, t));
                t += 0.02;
            }
            points.push(GSAPBezierSpline.interpolateCubicBezier(start, control1, control2, end, 1));
        });

        return points;
    }

    // B(t) = (1 - t)^3P0 + 3(1 - t)^2tP1 + 3(1 - t)t^2P2 + t^3P3
    private static interpolateCubicBezier(start:PIXI.Point, control1:PIXI.Point, control2:PIXI.Point, end:PIXI.Point, t:number = 0.5):PIXI.Point {
        let point:PIXI.Point = new PIXI.Point();

        point.x = (Math.pow(1 - t, 3) * start.x) +
            (3 * Math.pow(1 - t, 2) * t * control1.x) +
            (3 * (1 - t) * Math.pow(t, 2) * control2.x) +
            (Math.pow(t, 3) * end.x);

        point.y = (Math.pow(1 - t, 3) * start.y) +
            (3 * Math.pow(1 - t, 2) * t * control1.y) +
            (3 * (1 - t) * Math.pow(t, 2) * control2.y) +
            (Math.pow(t, 3) * end.y);

        return point;
    }
}